import { Box, Typography } from "@material-ui/core";
import { ButtonWrap, Icon, IconName, SanitizedHtml } from "halifax";
import clsx from 'clsx';
import React, { FC } from "react";
import * as TextConstants from "../textConstants";
import "./../styles.scss";

interface FlightMissedConnectionGuaranteeProps {
  isVITripSelected?: boolean;
  isMobile?: boolean;
  onClick: () => void;
}

export const FlightMissedConnectionGuarantee: FC<FlightMissedConnectionGuaranteeProps> = ({
  isVITripSelected,
  isMobile = false,
  onClick,
}) => {

  return <Box className={clsx("flight-missed-connection-wrapper", { mobile: isMobile })}>
    <ButtonWrap
      aria-labelledby="flight-missed-connection-popover"
      onClick={onClick}
    >
      <Icon name={IconName.CheckCircleFilledGreen} />
      <Typography variant="subtitle2" className="title-wrapper">
        <SanitizedHtml
          as="span"
          className="title"
          html={
            isVITripSelected
              ? TextConstants.LAYOVER_PROTECTED_MISSED_CONNECTION_REBOOKING
              : TextConstants.LAYOVER_PROTECTED_MISSED_CONNECTION_GUARANTEE
          }
        />
      </Typography>
      <Icon name={IconName.InfoCircle} className="info-icon" />
    </ButtonWrap>
  </Box>
}
